import { IconType } from '../../icons/icons.component';
import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-grey-icon',
    templateUrl: './grey-icons.component.html',
    styleUrls: ['./grey-icons.component.scss'],
})
export class GreyIconsComponent implements OnInit {
    @Input() greyIcon: GreyIconType;

    constructor() {}

    ngOnInit(): void {}
}

export type GreyIconType =
    | IconType
    | 'grey-trophy'
    | 'grey-right-direction'
    | 'grey-wallet'
    | 'grey-safelock'
    | 'grey-target'
    | 'grey-shop'
    | 'grey-approval'
    | 'grey-question-mark'
    | 'grey-piggy'
    | 'grey-money-hand'
    | 'grey-overdraft'
    | 'grey-users'
    | 'grey-home'
    | 'grey-paper'
    | 'grey-grid'
    | 'grey-logistics'
    | 'grey-pos-terminal'
    | 'grey-inventory'
    | 'grey-bill-payment'
    | 'grey-transfer-deposit'
    | 'grey-eye'
    | 'grey-eye-small'
    | 'grey-deposit'
    | 'grey-airtime'
    | 'grey-all-transactions'
    | 'grey-purchase'
    | 'grey-invoices'
    | 'grey-account'
    | 'grey-card'
    | 'grey-web'
    | 'grey-cash-book'
    | 'grey-customer'
    | 'grey-employment-and-payroll'
    | 'grey-vendor'
    | 'grey-network'
    | 'grey-dispute'
    | 'grey-pinpad'
    | 'grey-reset'
    | 'grey-exclamation'
    | 'grey-bank'
    | 'grey-caret-down'
    | 'grey-circle'
    | 'grey-table-details-icon'
    | 'grey-contact'
    | 'grey-packet'
    | 'grey-carton'
    | 'grey-drop-down'
    | 'grey-naira'
    | 'grey-earnings'
    | 'grey-empty-bin'
    | 'grey-performance'
    | 'grey-user-header-icon'
    | 'grey-date-input-icon'
    | 'grey-customer2'
    | 'grey-stop-watch'
    | 'grey-pos-transfer'
    | 'brm-user'
    | 'grey-delivery'
    | 'grey-ios'
    | 'grey-android'
    | 'new-badge-icon'
    | 'grey-logout'
    | 'food-and-drinks-icon'
    | 'grey-coolicon-icon'
    | 'grey-support-icon'
    | 'grey-reset-pin'
    | 'grey-phone'
    | 'grey-email'
    | 'grey-avatar'
    | 'grey-right-arrow'
    | 'grey-delete'
    | 'grey-search'
    | 'grey-search-alt'
    | 'grey-portfolio-mgmt'
    | 'grey-loan-request'
    | 'grey-income-commissions'
    | 'grey-wcl-wallet'
    | 'grey-persona-info'
    | 'grey-login-options'
    | 'ussd'
    | 'grey-fvs-verification'
    | 'grey-security'
    | 'grey-dropdown'
    | 'grey-number'
    | 'grey-text'
    | 'grey-boolean'
    | 'grey-info-icon'
    | 'grey-location-pin';
